// extracted by mini-css-extract-plugin
export default {"container":"DeleteClient_container__4kSzv","red_button":"DeleteClient_red_button__IEjgA","blue_button":"DeleteClient_blue_button__9OI+c","buttons":"DeleteClient_buttons__kSLaQ"};